import { MenuItem, TextField } from "@mui/material";
import useAuditStore from "./useAuditStore";
import { useParams } from "react-router-dom";
import API from "../../../services/API";

export default function Answer({row}){

    const {course} = useParams()

    const {tab, patient, updateRow} = useAuditStore();

    const handleChange = (event) => {

        const oldRow = row;

        let newRow = JSON.parse(JSON.stringify(row));

        newRow[tab][patient] = event.target.value;

        updateRow(newRow);

        API.post(`/courses/${course}/audit/answers`, newRow)
            .then(r => console.log(r.data))
            .catch(_ => updateRow(oldRow))
    }

    return (
        <TextField
            select
            value={row[tab][patient] || ''}
            onChange={handleChange}
            size='small'
            sx={{width: 100, height: 34}}
        >
            <MenuItem value=''></MenuItem>
            <MenuItem value='OUI'>OUI</MenuItem>
            <MenuItem value='NON'>NON</MenuItem>
            <MenuItem value='NA'>NA</MenuItem>
        </TextField>
    )
}
